<template>
  <v-btn
    icon
    :href="readableUrl"
    target="_blank"
    x-large
    :title="label"
  >
    <v-icon>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    readableUrl() {
      if (!this.url) {
        return
      }
      if (!/^https?:\/\//.test(this.url)) {
        return "http://" + this.url
      }
      return this.url
    }
  }
}
</script>

<style>
</style>